<!--二代温度计-->
<template>
  <el-form
    :model="model"
    label-width="150px"
    label-position="right"
    ref="form"
    :hide-required-asterisk="mode === 'view'"
    label-suffix="："
  >
    <el-row>
      <el-col :span="span">
        <!-- 采集模式 -->
        <el-form-item :label="$t('device.sample_mode')" prop="sampleMode">
          <el-select
            v-if="!isClickConfig"
            style="width: 250px"
            v-model.trim="model.sampleMode"
          >
            <el-option
              :value="key"
              :key="key"
              :label="item.title"
              v-for="(item, key) in ENUM_RE_TWO_GEN_ZIGBEE_WORK_MODE"
            ></el-option>
          </el-select>
          <template v-else>
            <span
              v-if="
                rowData['configStatus'] !== 2 &&
                  model['sampleModeCurrent'] &&
                  model['sampleModeCurrent'].change
              "
            >
              <template v-if="model['sampleModeCurrent']">
                {{
                  model['sampleModeCurrent'].current &&
                    ENUM_RE_TWO_GEN_ZIGBEE_WORK_MODE[
                      model['sampleModeCurrent'].current
                    ].title
                }}
              </template>
              --></span
            >
            <span
              v-if="model['sampleModeCurrent']"
              :style="mode === 'edit' && 'color:red'"
              >{{
                ENUM_RE_TWO_GEN_ZIGBEE_WORK_MODE[
                  model['sampleModeCurrent'].modify
                ].title
              }}</span
            >

            <span v-else-if="model.sample_mode">
              {{ ENUM_RE_TWO_GEN_ZIGBEE_WORK_MODE[model.sample_mode].title }}
            </span>
          </template>
        </el-form-item>
      </el-col>

      <!--异步模式-->
      <template
        v-if="
          (model.sampleMode || model.sample_mode) ==
            ENUM_TWO_GEN_ZIGBEE_WORK_MODE.ASYNC
        "
      >
        <el-col :span="span">
          <!-- 采集间隔 -->
          <el-form-item
            :label="$t('device.sample_interval')"
            prop="sampleInterval"
            :rules="RuleRequiredFunc($t('integration.cannot_be_empty'))"
          >
            <el-input
              v-if="!isClickConfig"
              style="width: 250px"
              v-model.trim="model.sampleInterval"
            />

            <template v-else>
              <span
                v-if="
                  rowData['configStatus'] !== 2 &&
                    model['sampleIntervalCurrent'] &&
                    model['sampleIntervalCurrent'].change
                "
                >{{ model['sampleIntervalCurrent'].current + '-->' }}</span
              >
              <span
                v-if="model['sampleIntervalCurrent']"
                :style="mode === 'edit' && 'color:red'"
                >{{ model['sampleIntervalCurrent'].modify }}</span
              >
              <span v-else>
                {{ model.sample_interval }}
              </span>
            </template>
          </el-form-item>
        </el-col>

        <el-col :span="span">
          <!-- 正常上报间隔 -->
          <el-form-item
            :label="$t('device.normal_reporting_interval')"
            prop="normalReportInterval"
            :rules="RuleRequiredFunc($t('integration.cannot_be_empty'))"
          >
            <el-input
              v-if="!isClickConfig"
              style="width: 250px"
              v-model.trim="model.normalReportInterval"
            />

            <template v-else>
              <span
                v-if="
                  rowData['configStatus'] !== 2 &&
                    model['normalReportIntervalCurrent'] &&
                    model['normalReportIntervalCurrent'].change
                "
                >{{
                  model['normalReportIntervalCurrent'].current + '-->'
                }}</span
              >
              <span
                v-if="model['normalReportIntervalCurrent']"
                :style="mode === 'edit' && 'color:red'"
                >{{ model['normalReportIntervalCurrent'].modify }}</span
              >

              <span v-else>
                {{ model.normal_report_interval }}
              </span>
            </template>
          </el-form-item>
        </el-col>

        <el-col :span="span">
          <!-- 异常上报间隔 -->
          <el-form-item
            :label="$t('device.abnormal_reporting_interval')"
            prop="abnormalReportInterval"
            :rules="RuleRequiredFunc($t('integration.cannot_be_empty'))"
          >
            <el-input
              v-if="!isClickConfig"
              style="width: 250px"
              v-model.trim="model.abnormalReportInterval"
            />

            <template v-else>
              <span
                v-if="
                  rowData['configStatus'] !== 2 &&
                    model['abnormalReportIntervalCurrent'] &&
                    model['abnormalReportIntervalCurrent'].change
                "
                >{{
                  model['abnormalReportIntervalCurrent'].current + '-->'
                }}</span
              >
              <span
                v-if="model['abnormalReportIntervalCurrent']"
                :style="mode === 'edit' && 'color:red'"
                >{{ model['abnormalReportIntervalCurrent'].modify }}</span
              >

              <span v-else>
                {{ model.abnormal_report_interval }}
              </span>
            </template>
          </el-form-item>
        </el-col>
      </template>

      <template
        v-if="
          (model.sampleMode || model.sample_mode) ==
            ENUM_TWO_GEN_ZIGBEE_WORK_MODE.SYNC
        "
      >
        <el-col :span="span">
          <!-- 同步采集间隔 -->
          <el-form-item
            :label="$t('device.async_sample_interval')"
            prop="syncInterval"
            :rules="RuleRequiredFunc($t('integration.cannot_be_empty'))"
          >
            <el-input
              v-if="!isClickConfig"
              style="width: 250px"
              v-model.trim="model.syncInterval"
            />

            <template v-else>
              <span
                v-if="
                  rowData['configStatus'] !== 2 &&
                    model['syncIntervalCurrent'] &&
                    model['syncIntervalCurrent'].change
                "
                >{{ model['syncIntervalCurrent'].current + '-->' }}</span
              >
              <span
                v-if="model['syncIntervalCurrent']"
                :style="mode === 'edit' && `color:red`"
                >{{ model['syncIntervalCurrent'].modify }}</span
              >

              <span v-else>
                {{ model.syncInterval }}
              </span>
            </template>
          </el-form-item>
        </el-col>
      </template>

      <template
        v-if="
          (model.sampleMode || model.sample_mode) ==
            ENUM_TWO_GEN_ZIGBEE_WORK_MODE.FIXED
        "
      >
        <el-col :span="span">
          <!-- 固定采集间隔 -->
          <el-form-item
            :label="$t('device.fix_sample_interval')"
            prop="gapInterval"
            :rules="RuleRequiredFunc($t('integration.cannot_be_empty'))"
          >
            <el-input
              v-if="!isClickConfig"
              style="width: 250px"
              v-model.trim="model.gapInterval"
            />

            <template v-else>
              <span
                v-if="
                  rowData['configStatus'] !== 2 &&
                    model['gapIntervalCurrent'] &&
                    model['gapIntervalCurrent'].change
                "
                >{{ model['gapIntervalCurrent'].current + '-->' }}</span
              >
              <span
                v-if="model['gapIntervalCurrent']"
                :style="mode === 'edit' && 'color:red'"
                >{{ model['gapIntervalCurrent'].modify }}</span
              >
              <span v-else>
                {{ model.gap_interval }}
              </span>
            </template>
          </el-form-item>
        </el-col>
      </template>
    </el-row>
  </el-form>
</template>

<script>
import { ENUM_RE_TWO_GEN_ZIGBEE_WORK_MODE } from '@/common/enum/reverse/device'

import { getGenTwoTempDefaultConfig } from './default'
import { ENUM_TWO_GEN_ZIGBEE_WORK_MODE } from '@/common/enum/forward/device'
import { RuleRequiredFunc } from '@/utils/rules'

/**
 * 二代类型配置封装
 * 外部参数格式化有两种方式 获取需要提交数据调用本组件getData  会自动进行校验
 * 1.调用setData 适用于服务器原生为经过处理的数据
 * 2.传入dioForm  适用于已经格式化好的数据
 */
export default {
  computed: {
    ENUM_TWO_GEN_ZIGBEE_WORK_MODE () {
      return ENUM_TWO_GEN_ZIGBEE_WORK_MODE
    },
    ENUM_RE_TWO_GEN_ZIGBEE_WORK_MODE () {
      return ENUM_RE_TWO_GEN_ZIGBEE_WORK_MODE
    },
    mode () {
      return this.dioForm ? 'view' : 'edit'
    }
  },
  props: {
    isClickConfig: {},
    rowData: {
      default: () => ({})
    },
    span: {
      default: 24
    },
    dioForm: {}
  },
  watch: {
    dioForm: {
      immediate: true,
      handler () {
        if (this.dioForm && this.dioForm.sample_mode) {
          this.model = { ...this.dioForm }
        } else {
          this.model = getGenTwoTempDefaultConfig()

        }
      }
    }
  },
  data () {
    return {
      model: {}
    }
  },
  methods: {
    RuleRequiredFunc,
    // export 给外部调用
    async getData () {
      await this.$refs.form.validate()
      return this.model
    },
    // export 给外部调用
    setData (JsonContent) {
      if (!JsonContent.item) {
        return (this.model = { ...JsonContent })
      }
      this.model = {
        sampleMode: JsonContent.item.sample_mode.modify,
        sampleModeCurrent: JsonContent.item.sample_mode,

        sampleInterval:
          JsonContent.item.sample_interval &&
          JsonContent.item.sample_interval.modify,
        sampleIntervalCurrent: JsonContent.item.sample_interval,

        normalReportInterval:
          JsonContent.item.normal_report_interval &&
          JsonContent.item.normal_report_interval.modify,
        normalReportIntervalCurrent: JsonContent.item.normal_report_interval,

        abnormalReportInterval:
          JsonContent.item.abnormal_report_intervals &&
          JsonContent.item.abnormal_report_intervals.modify,
        abnormalReportIntervalCurrent:
          JsonContent.item.abnormal_report_intervals,

        syncInterval:
          JsonContent.item.sync_interval &&
          JsonContent.item.sync_interval.modify,
        syncIntervalCurrent: JsonContent.item.sync_interval,

        gapInterval:
          JsonContent.item.gap_interval && JsonContent.item.gap_interval.modify,
        gapIntervalCurrent: JsonContent.item.gap_interval
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-form-item__content {
  text-align: left;
}
</style>
